import { forwardRef, type TextareaHTMLAttributes, type ReactNode } from 'react'
import { cn } from '@/lib/utils'

interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: ReactNode
  hint?: ReactNode
  error?: string
  mono?: boolean
}

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ label, hint, error, mono, className, ...props }, ref) => {
    return (
      <div className="w-full">
        {label && (
          <label className="text-[10px] uppercase tracking-wider text-slate-500 font-semibold mb-1 block">
            {label}
          </label>
        )}
        <textarea
          ref={ref}
          className={cn(
            'w-full px-3 py-2 border border-slate-300 rounded-md text-sm focus:border-amber-500 focus:outline-none transition resize-y',
            mono && 'font-mono text-[12px] bg-slate-50',
            error && 'border-rose-400',
            className
          )}
          {...props}
        />
        {hint && !error && <p className="text-[11px] text-slate-500 mt-1">{hint}</p>}
        {error && <p className="text-[11px] text-rose-600 mt-1">{error}</p>}
      </div>
    )
  }
)
Textarea.displayName = 'Textarea'
